module.exports = __webpack_public_path__ + "img/polls.05e3acdd.svg";